import { RetailerType, MetaData } from '..';

export class RetailerTypeDto {
  constructor(public metadata: MetaData, public results: RetailerType[]) {}
}
